import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { PaginationPageSizes } from 'src/app/constants';

@Component({
  selector: 'app-custom-grid-pagination',
  templateUrl: './custom-grid-pagination.component.html',
  styleUrls: ['./custom-grid-pagination.component.scss']
})
export class CustomGridPaginationComponent implements OnInit, OnChanges, OnDestroy {

  @Input() idString: string;

  @Input() selectedPageSizeValue: any;

  @Input() startIndex: any;

  @Input() endIndex: any;

  @Input() totalRecordsCount: any;

  @Input() currentPage: any;

  @Input() totalPages: any;

  @Input() restrictPagesizeValueToFifty: any;

  // Page sizes shown in the dropdown. Defaults to the shared list; a parent can
  // pass a custom array to override what's offered.
  @Input() paginationPageSizes = PaginationPageSizes;

  // When true, the page-size dropdown is hidden (nav controls/summary remain).
  @Input() hidePageSizeSelector = false;

  @Output() onPaginationCompUpdate = new EventEmitter();

  destroySubscription = false;

  constructor() { }

  ngOnInit() {
  }

  onPageSizeChanged() {
    const tempObj = {
      action: 'onPageSizeChanged',
      value: Number(this.selectedPageSizeValue)
    }
    this.onPaginationCompUpdate.emit(tempObj);
  }

  firstPageClick() {
     if (this.currentPage < 2) {
      return;
    }
    const tempObj = {
      action: 'firstPageClick'
    }
    this.onPaginationCompUpdate.emit(tempObj);
  }

  prevPageClick() {
     if (this.currentPage < 2) {
      return;
    }
    const tempObj = {
      action: 'prevPageClick'
    }
    this.onPaginationCompUpdate.emit(tempObj);
  }

  nextPageClick() {
    if (this.currentPage === this.totalPages) {
      return;
    }
    const tempObj = {
      action: 'nextPageClick'
    }
    this.onPaginationCompUpdate.emit(tempObj);
  }

  lastPageClick() {
    if (this.currentPage === this.totalPages) {
      return;
    }
    const tempObj = {
      action: 'lastPageClick'
    }
    this.onPaginationCompUpdate.emit(tempObj);
  }

  ngOnChanges() {
    this.startIndex = this.startIndex;
    this.endIndex = this.endIndex;
    this.totalRecordsCount = this.totalRecordsCount;
    this.currentPage = this.currentPage;
    this.totalPages = this.totalPages;
  }

  ngOnDestroy() {
    this.destroySubscription = true;
  }
}
